import React, { useContext, useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import Tab from "../../Components/Tab";
import PageHead from "../../Components/PageHead";
import { formatDateToMMDDYYYY, formatDateToUsaMMDDYYYY, GetAllSchoolsByLocation, getTypeWatchDelay, typewatch } from "../../JS/Common";
import { ApiGetCall, ApiGetCallAuthKey, ApiGetCDNData, ApiPostCall } from "../../JS/Connector";
import Popup from "../../Components/Popup";
import AlertsComp from "../../Components/AlertsComp";
import AlertPopup from "../../Components/AlertPopup";
import { log } from "../../JS/Logger";
import { useSelector } from "react-redux";
import useConfig from "../../Hooks/useConfig";

export default function PartsOrders() {
    const { organization, adminCallNode } = useConfig();
    const StateData = useSelector((state) => state.authData);
    const [LimitForPagination, setLimitForPagination] = useState(25);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [pageRangeCount, setpageRangeCount] = useState(0);
    const [partsOrderTab, setPartsOrderTab] = useState({
        pending: "active",
        completed: "",
    });
    const [SearchForPending, setSearchForPending] = useState("");
    const [SearchForCompeleted, setSearchForCompleted] = useState("");
    const [showBatchPopup, setShowBatchPopup] = useState(false);
    const [partsOrderData, setPartsOrderData] = useState([]);
    const [batchData, setBatchData] = useState([]);
    const [sortingDetails, setSortingDetails] = useState({
        columnName: "",
        sortFlag: "desc"
    });
    const [showMasterList, setShowMasterList] = useState(false);
    const [masterListData, setMasterListData] = useState({
        isLoading: false,
        data: [],
    });
    const [fullfillSearchText, setFulFillSearch] = useState('');
    const [NewAlerts, setNewAlerts] = useState("");
    const [Locations, setLocations] = useState([]);
    const [Schools, setSchools] = useState([]);
    const [LocationValue, setLocationValue] = useState('');
    const [SchoolValue, setSchoolValue] = useState('');
    const [SchoolFilterData, setSchoolFilterData] = useState([]);
    const [ItemsHover, setItemsHover] = useState(false);
    const [showSearchBarPopup, setShowSearchBarPopup] = useState({
        show: false,
        item: null,
    })
    const [showCompleteConfirmPopup, setShowCompleteConfirmPopup] = useState({
        show: false,
        item: null,
    });
    const showPagination = partsOrderData?.length > 0;
    useEffect(() => {
        if (partsOrderTab.pending == "active") {
            GetPartsOrders(1, null, sortingDetails.columnName || null, sortingDetails.sortFlag, null, null, false);
        } else {
            GetPartsOrders(2, null, sortingDetails.columnName || null, sortingDetails.sortFlag, null, null, false);
        }
    }, [currentPage, LimitForPagination, partsOrderTab]);

    async function GetPartsOrders(flag, SearchString, columnName, sFlag, Sid, Lid, toogleSort) {
        if (!SearchString) SearchString = null;
        if (!columnName) columnName = null;
        if (toogleSort) sFlag = sFlag == "asc" ? "desc" : "asc";

        setSortingDetails({ ...sortingDetails, columnName: columnName, sortFlag: sFlag })

        if (!Lid || Lid == "0") {
            Lid = null
        }

        if (!Sid || Sid == "0") {
            Sid = null
        }

        typewatch(async function () {
            setLoading(true)
            await ApiGetCall(`/part-orders/list?flag=${flag}&locationId=${Lid}&schoolId=${Sid}&search=${SearchString}&sortBy=${columnName}&sortByOrder=${sFlag}&page=${currentPage}&limit=${LimitForPagination}`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    setLoading(false);
                    const responseRs = JSON.parse(result);
                    setpageRangeCount(responseRs.msg.total)
                    setPartsOrderData(responseRs.msg.data?.length ? responseRs.msg.data : [])
                }
            });
        }, getTypeWatchDelay(SearchString, 500));
    }

    async function GetBatchDetails(id) {
        setLoading(true);
        setBatchData([]);
        typewatch(async function () {
            await ApiGetCall(`/part-orders/by-id?uuid=${id}`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    setLoading(false);
                    const responseRs = JSON.parse(result);
                    if (responseRs.msg) {
                        setBatchData(responseRs.msg)
                    } else {
                        setBatchData([]);
                    }
                }
            });
        }, 500);
    }

    function handleTabClick(tabType) {
        setLocationValue("0");
        setSchoolValue("0");
        setSchoolFilterData(Schools)
        setCurrentPage(1);
        if (tabType == "pending") {
            setPartsOrderData([]);
            GetPartsOrders(1, SearchForPending || null, null, "asc", null, null, false);
            setPartsOrderTab({ ...partsOrderTab, pending: "active", completed: "" });
        } else if (tabType == "completed") {
            setPartsOrderData([]);
            GetPartsOrders(2, SearchForCompeleted || null, null, "asc", null, null, false);
            setPartsOrderTab({ ...partsOrderTab, pending: "", completed: "active" });
        }
    }

    const handleBatchPopup = (id) => {
        setShowBatchPopup(!showBatchPopup);
        GetBatchDetails(id);
    }

    function handleSearchChange(e) {
        partsOrderTab.pending == 'active' ? setSearchForPending(e.target.value) : setSearchForCompleted(e.target.value);
        setCurrentPage(1);
        GetPartsOrders(partsOrderTab.pending == 'active' ? 1 : 2, e.target.value, null, sortingDetails.sortFlag, null, null, false);
    }

    const handleMasterModalInput = (e, id) => {
        let value = e.target.value;
        if (isNaN(value)) value = null;
        setBatchData((prev) => ({
            ...prev,
            part_order_items: prev.part_order_items.map((device) =>
                device.id === id ? { ...device, newly_fulfilled_quantity: value } : device
            )
        }));
    };

    async function GetMasterList(searchString) {
        if (searchString?.trim() == "" || searchString == undefined) {
            searchString = null;
        } else {
            searchString = searchString?.trim();
        }
        setMasterListData({ ...masterListData, isLoading: true });
        typewatch(async function () {
            var result = await ApiGetCall(`${adminCallNode}/parts/all?search=${searchString}&ticketId=null&seeMore=${0}`);
            if (!result || result == undefined || result == "") {
                alert("Something went wrong");
                setMasterListData({ ...masterListData, isLoading: false, data: [] });
                return;
            } else {
                const responseRs = JSON.parse(result);
                setMasterListData({ ...masterListData, isLoading: false, data: responseRs?.msg?.length > 0 ? responseRs.msg : [] });

            }
        }, 500);
    };

    const handleFulFillDevice = (item, deviceDetail) => {
        setBatchData((prev) => ({
            ...prev,
            part_order_items: prev.part_order_items.map((device) =>
                device.id === deviceDetail.id ? { ...device, fulfilled_device_name: item.title, fulfilled_partsku_id: item.id, netsuite_internal_sku: item.netsuite_internal_sku } : device
            )
        }));
        setShowSearchBarPopup({ ...showSearchBarPopup, show: false })
    }

    async function FulFillOrder() {
        const FullFillArray = batchData.part_order_items.map(item => ({
            "id": item.id,
            "part_order_id": item.part_order_id,
            "partsku_id": item.partsku_id,
            "requested_school_part": item.requested_school_part,
            "fulfilled_partsku_id": item.fulfilled_partsku_id,
            "fulfilled_device_name": item.fulfilled_device_name,
            "requested_quantity": item.requested_quantity,
            "fulfilled_quantity": item.fulfilled_quantity == null ? 0 : item.newly_fulfilled_quantity == null ? 0 : parseInt(item.newly_fulfilled_quantity),
            "netsuite_internal_sku": item.fulfill_netsuite_internal_sku != null ? item.fulfill_netsuite_internal_sku : item.netsuite_internal_sku,
            "note": item.note
        }))
        const newErrors = {};
        let isAnyOneFulfilled = false;
        FullFillArray?.forEach(part => {
            if (!part.fulfilled_device_name) {
                newErrors[part.id] = "Replace Part Error";
                setNewAlerts(<AlertsComp show={true} variant="danger" msg={"Attach a part to each line item before proceeding."} />)
                setTimeout(() => {
                    setNewAlerts(<AlertsComp show={false} />);
                }, 2000)
                return;
            } else if (!part.netsuite_internal_sku || part.netsuite_internal_sku.trim() === "") {
                newErrors[part.id] = "NetSuite SKU Error";
                setNewAlerts(<AlertsComp show={true} variant="danger" msg={"NetSuite SKU is required!"} />)
                setTimeout(() => {
                    setNewAlerts(<AlertsComp show={false} />);
                }, 2000)
                return;
            } else if (part.fulfilled_quantity > 0) {
                isAnyOneFulfilled = true;
            }
        });
        const hasMissingSKU = Object.keys(newErrors).length > 0;
        if (hasMissingSKU) {
            return;
        }
        if (isAnyOneFulfilled == false) {
            setNewAlerts(<AlertsComp show={true} variant="danger" msg={"Please fulfill at least one part!"} />);
            setTimeout(() => {
                setNewAlerts(<AlertsComp show={false} />);
            }, 2000)
            return
        }
        var raw = JSON.stringify({
            data: {
                "uuid": batchData.id,
                "school_id": batchData.school_id,
                "part_order_items": FullFillArray,
            }
        })
        setLoading(true)
        await ApiPostCall("/part-orders/fulfill", raw).then((result) => {
            if (!result || result == undefined || result == "" || result == "Something Went Wrong") {
                setLoading(false)
                alert("Something went wrong");
            } else {
                setLoading(false)
                setNewAlerts(<AlertsComp show={true} variant="success" msg={"Order Fulfilled successfully!"} />)
                setTimeout(() => {
                    setNewAlerts(<AlertsComp show={false} />);
                    setShowBatchPopup(!showBatchPopup);
                    GetPartsOrders(1);
                }, 2000)
            }
        })
    }
    async function FinalizeBatchBilling(BatchId) {
        setLoading(true)
        var raw = JSON.stringify({
            "orderId": BatchId
        })
        await ApiPostCall("/part-orders/update-to-completed", raw).then((result) => {
            const response = JSON.parse(result);
            if (!result || result == undefined || result == "" || result == "Something Went Wrong") {
                setLoading(false)
                setNewAlerts(<AlertsComp show={true} variant="danger" msg={"Something went wrong!"} />)
                setTimeout(() => {
                    setNewAlerts(<AlertsComp show={false} />);
                    setShowCompleteConfirmPopup({ ...showCompleteConfirmPopup, show: false });
                }, 3000)
            } else if (response.response == "error") {
                setLoading(false)
                setNewAlerts(<AlertsComp show={true} variant="danger" msg={response.msg} />)
                setTimeout(() => {
                    setNewAlerts(<AlertsComp show={false} />);
                    setShowCompleteConfirmPopup({ ...showCompleteConfirmPopup, show: false });
                }, 3000)
            } else {
                setLoading(false)
                setNewAlerts(<AlertsComp show={true} variant="success" msg={"Parts Order marked as Completed!"} />)
                setTimeout(() => {
                    setNewAlerts(<AlertsComp show={false} />);
                    GetPartsOrders(1)
                    setShowCompleteConfirmPopup({ ...showCompleteConfirmPopup, show: false });
                }, 2000)
            }
        })
    }

    const handleLocationValue = (val) => {
        setLocationValue(val);
        if (val == "0") {
            setSchoolFilterData(Schools)
            GetPartsOrders(partsOrderTab.pending == 'active' ? 1 : 2, partsOrderTab.pending == 'active' ? SearchForPending : SearchForCompeleted, null, null, SchoolValue, val, false)
        } else {
            var filterSchoolByLocation = Locations?.filter((data) => data?.id == val)
            setSchoolFilterData(filterSchoolByLocation[0]?.school?.slice()?.sort((a, b) => a.name.localeCompare(b.name)))
            GetPartsOrders(partsOrderTab.pending == 'active' ? 1 : 2, partsOrderTab.pending == 'active' ? SearchForPending : SearchForCompeleted, null, null, null, val, false)
        }
    }

    useEffect(() => {
        GetAllSchoolsByLocation({ setLocations, setSchoolFilterData, setAllSchool: setSchools });
    }, [])

    const handlePartsSorting = (column) => {
        if (SchoolValue.trim() !== "" || SchoolValue !== "0") {
            GetPartsOrders(partsOrderTab.pending == 'active' ? 1 : 2, partsOrderTab.pending == 'active' ? SearchForPending : SearchForCompeleted, column, sortingDetails.sortFlag, SchoolValue, null, true);
        } else if (LocationValue.trim() !== "" || LocationValue !== "0") {
            GetPartsOrders(partsOrderTab.pending == 'active' ? 1 : 2, partsOrderTab.pending == 'active' ? SearchForPending : SearchForCompeleted, column, sortingDetails.sortFlag, null, LocationValue, true);
        } else {
            GetPartsOrders(partsOrderTab.pending == 'active' ? 1 : 2, partsOrderTab.pending == 'active' ? SearchForPending : SearchForCompeleted, column, sortingDetails.sortFlag, null, null, true);
        }
    }

    async function ExtraDocument(FedExQr) {
        try {
            const blob = await ApiGetCDNData("/" + FedExQr, StateData?.Schoolnumber);
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = FedExQr.split('/').pop();
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        } catch (error) {
            log.error("Error downloading file:", error);
        }
    }

    const batchModalBody = (
        <>
            <div className="row mx-0 align-items-center">
                <div style={{ fontSize: '16px' }} className="mb-3">
                    <b>Order No :</b> {batchData.part_order_num || "-"}
                </div>
            </div>
            <div id="batchModalBody" className="parent greyBox" style={{ maxHeight: "400px", overflowY: 'auto' }}>
                <div className="GridHeader brdr-Btm">
                    <div className="row mx-0 ">
                        <div className="col-md-2 cursor-context-menu" title=" Rquested Part ">Requested</div>
                        <div className="col-md-4">
                            <div className="row">
                                <div className={`cursor-context-menu ${partsOrderTab.pending == "active" ? 'col-md-4' : 'col-md-6'}`} title=" Rquested Quantity ">Qty</div>
                                {partsOrderTab.pending == "active" && <div className="col-md-4"> Progress</div>}
                                <div className={`cursor-context-menu ${partsOrderTab.pending == "active" ? 'col-md-4' : 'col-md-6'}`} title=" Fulfilled Quantity ">{partsOrderTab.pending == "active" ? "Fulfilled" : "Progress"}</div>
                            </div>
                        </div>
                        <div className="col-md-2 cursor-context-menu" title=" NetSuite Internal SKU">NetSuite SKU </div>
                        <div className="col-md-2">Fulfilled Part</div>
                        <div className="col-md-2">
                            Notes
                        </div>
                    </div>
                </div>
                <div>
                    {batchData && batchData?.part_order_items?.length > 0 &&
                        batchData.part_order_items.map((partDetails) => (
                            <div
                                className="row mx-0 py-12 OddEvenClass tableBorderHide"
                                key={partDetails.id}
                            >
                                <div className="col-md-2 text-wrap">
                                    {partDetails.requested_school_part || "-"}
                                </div>

                                <div className="col-md-4">
                                    <div className="row">
                                        <div className={`${partsOrderTab.pending == "active" ? 'col-md-4' : 'col-md-6'}`}>
                                            {partDetails.requested_quantity || "-"}
                                        </div>
                                        <div className={`${partsOrderTab.pending == "active" ? 'col-md-4' : 'col-md-6'}`}>
                                            <div className="w-100">
                                                {partDetails.fulfilled_quantity} - Fulfilled
                                            </div>
                                            <div className="w-100">
                                                {partDetails.billed_fulfill_quantity} - Billed
                                            </div>
                                            <div className="w-100">
                                                {partDetails.fulfilled_quantity - partDetails.billed_fulfill_quantity} - Unbilled
                                            </div>
                                        </div>

                                        <div className={`${partsOrderTab.pending == "active" ? 'col-md-4' : 'col-md-6'}`}>
                                            {partsOrderTab.pending === 'active' &&
                                                <input
                                                    type="number"
                                                    min={0}
                                                    max={partDetails.requested_quantity}
                                                    autoComplete="off"
                                                    style={{ outline: 'none' }}
                                                    className="form-control w-100"
                                                    value={partDetails?.newly_fulfilled_quantity}
                                                    onKeyDown={(e) => {
                                                        if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                                            e.preventDefault();
                                                            return;
                                                        }
                                                    }}
                                                    onChange={(e) => handleMasterModalInput(e, partDetails.id)}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    {partDetails.fulfilled_device_name != null ? (
                                        <>
                                            {partDetails.netsuite_internal_sku != null ? partDetails.netsuite_internal_sku
                                                : (
                                                    <input type="text" className="form-control bg-transparent w-100" value={partDetails.fulfill_netsuite_internal_sku == null ? partDetails.netsuite_internal_sku : partDetails.fulfill_netsuite_internal_sku} onChange={(e) => {
                                                        setBatchData((prev) => ({
                                                            ...prev,
                                                            part_order_items: prev.part_order_items.map((device) => device.id === partDetails.id ? { ...device, fulfill_netsuite_internal_sku: e.target.value } : device)
                                                        }))
                                                    }} />
                                                )}
                                        </>
                                    ) : partDetails.netsuite_internal_sku || "-"}
                                </div>
                                <div className="col-md-2 text-wrap">
                                    {partsOrderTab.pending === 'active' ? (
                                        <div className="d-flex flex-column">
                                            <label>{partDetails.fulfilled_device_name || "(Sorry, your requested part is not available)"}</label>
                                            <label className="cursor-pointer" style={{ width: 'fit-content' }} onClick={() => setShowSearchBarPopup({ ...showSearchBarPopup, show: true, item: partDetails })}><b><u>Attach Part</u></b></label>
                                        </div>
                                    ) : (
                                        <label>{partDetails.fulfilled_device_name || "-"}</label>
                                    )}
                                </div>
                                <div className="col-md-2">
                                    {partsOrderTab.pending === "active" ? (
                                        <textarea
                                            type="textarea"
                                            rows={2}
                                            autoComplete="off"
                                            name="partsOrderNote"
                                            className="form-control"
                                            value={partDetails.note}
                                            required
                                            onChange={(e) => {
                                                setBatchData((prev) => ({
                                                    ...prev,
                                                    part_order_items: prev.part_order_items.map((device) =>
                                                        device.id === partDetails.id ? { ...device, note: e.target.value } : device
                                                    )
                                                }))
                                            }}
                                        />
                                    ) : (
                                        partDetails.note || "-"
                                    )}
                                </div>
                            </div>
                        ))}
                </div>
            </div>
        </>

    )

    return (
        <React.Fragment>
            <PageHead
                LimitForPagination={LimitForPagination}
                setLimitForPagination={setLimitForPagination}
                setCurrentPage={setCurrentPage}
                heading={"Parts Orders"}
                loading={loading}
                handleSearch={handleSearchChange}
                showsearch={true}
                Alerts={NewAlerts}
            />
            <div className="GridBox mt-2 p-3">
                <div className="row pb-3">
                    <div className="col-md-8">
                        <ul className="nav nav-tabs">
                            <Tab isActive={partsOrderTab.pending == 'active'}
                                label='Pending Orders' onClick={() => handleTabClick('pending')} col={'col-md-4'} />
                            <Tab isActive={partsOrderTab.completed == 'active'}
                                label='Completed Orders' onClick={() => handleTabClick('completed')} col={'col-md-4'} />
                        </ul>
                    </div>

                    <div className="col-md-4 d-flex gap-2">
                        <div className="row w-100">
                            <div className="col-md-6 py-1 pe-0">
                                <select value={LocationValue} onChange={(e) => { handleLocationValue(e.target.value) }}>
                                    <option value="0">Filter by Location</option>
                                    {Locations.map((locationItem, j) => (
                                        <option value={locationItem.id} key={j}>
                                            {locationItem.location_name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-6 py-1 pe-0">
                                <select value={SchoolValue} onChange={(e) => {
                                    setSchoolValue(e.target.value);
                                    if (e.target.value == "0") {
                                        GetPartsOrders(partsOrderTab.pending == 'active' ? 1 : 2, partsOrderTab.pending == 'active' ? SearchForPending : SearchForCompeleted, null, null, null, LocationValue, false)
                                    } else {
                                        GetPartsOrders(partsOrderTab.pending == 'active' ? 1 : 2, partsOrderTab.pending == 'active' ? SearchForPending : SearchForCompeleted, null, null, e.target.value, LocationValue, false)
                                    }
                                }}>

                                    <option value="0">Filter by {organization}</option>
                                    {SchoolFilterData?.length == 0 && <optgroup label={`No ${organization} found`}></optgroup>}
                                    {SchoolFilterData?.map((item, j) => (
                                        <option value={item.id} key={j}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="greyBox p-3">
                    <table className="table data-table mb-0">
                        <thead>
                            <tr>
                                <th scope="col" title="Sort by Order No." className=" fw-600 cursor-pointer" onClick={() => handlePartsSorting("part_order_num")}>
                                    Order No.
                                    <img
                                        src="/images/sortbynew.svg"
                                        className="img-fluid ps-2 sortbyClass"
                                    />
                                </th>
                                <th scope="col" title={`Sort by ${organization} Name`} className=" fw-600 cursor-pointer" onClick={() => handlePartsSorting("school_name")}>
                                    {organization} Name
                                    <img
                                        src="/images/sortbynew.svg"
                                        className="img-fluid ps-2 sortbyClass"
                                    />
                                </th>
                                <th scope="col" title="Sort by Items" className=" fw-600 cursor-pointer" onClick={() => handlePartsSorting("items")}>
                                    Items
                                    <img
                                        src="/images/sortbynew.svg"
                                        className="img-fluid ps-2 sortbyClass"
                                    />
                                </th>
                                <th scope="col" title="Sort by Requested Date" className=" fw-600 cursor-pointer" onClick={() => handlePartsSorting("request_date")}>
                                    Requested Date
                                    <img
                                        src="/images/sortbynew.svg"
                                        className="img-fluid ps-2 sortbyClass"
                                    />
                                </th>
                                {partsOrderTab.completed === "active" && (
                                    <th scope="col" title="Sort by Fulflled Date" className=" fw-600 cursor-pointer" onClick={() => handlePartsSorting("fulfilled_at")}>
                                        Fulfilled Date
                                        <img
                                            src="/images/sortbynew.svg"
                                            className="img-fluid ps-2 sortbyClass"
                                        />
                                    </th>
                                )}
                                {partsOrderTab.pending === "active" && (
                                    <th scope="col" title="Sort by Status" className=" fw-600 cursor-pointer" onClick={() => handlePartsSorting("order_status")}>
                                        Status
                                        <img
                                            src="/images/sortbynew.svg"
                                            className="img-fluid ps-2 sortbyClass"
                                        />
                                    </th>
                                )}
                                <th scope="col" className=" fw-600">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {partsOrderData?.length != 0 ? (
                                partsOrderData?.map((item, i) => (
                                    <tr key={i} className="OddEvenClass tableBorderHide" style={{ height: "30px" }}>
                                        <td className="py-12">
                                            {item.part_order_num || "-"}
                                        </td>
                                        <td className="py-12">
                                            {item.school_name || "-"}
                                        </td>
                                        <td className={`py-12 ${ItemsHover === item.id ? 'overflow-visible' : ''}`} onMouseLeave={() => setItemsHover(false)}>
                                            <div className=" position-relative">
                                                <label className={`${partsOrderTab.pending == 'active' ? 'cursor-pointer text-decoration-underline' : ''}`}
                                                    onMouseEnter={() => setItemsHover(item.id)}
                                                >
                                                    {item.items || "-"}
                                                </label>
                                                {partsOrderTab.pending == 'active' && ItemsHover === item.id && (
                                                    <div className=" position-absolute bg-white shadow rounded-4 p-3" style={{ zIndex: 10 }}>
                                                        <div
                                                            className="row mx-0 overflow-x-hidden overflow-y-scroll"
                                                            style={{ width: '450px', maxHeight: '150px' }}
                                                        >
                                                            <div className="row mx-0 pb-2 mb-2 brdr-Btm">
                                                                <div className="col-md-10"><b>Item Name</b></div>
                                                                <div className="col-md-2"><b> Qty </b></div>
                                                            </div>
                                                            {item.item_details.map((innerItems, index) => (
                                                                <div className="row mx-0 py-2" key={index}>
                                                                    <div className="col-md-10 text-wrap">{innerItems.name}</div>
                                                                    <div className="col-md-2">{innerItems.qty}</div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                        <td className="py-12">
                                            {formatDateToMMDDYYYY(item.request_date) || "-"}
                                        </td>
                                        {partsOrderTab.completed === "active" && (
                                            <td className="py-12">
                                                {formatDateToMMDDYYYY(item.fulfilled_at) || "-"}
                                            </td>
                                        )}
                                        {partsOrderTab.pending === "active" && (
                                            <td className={`py-12`}>
                                                {item.batch_status_text || "-"}
                                            </td>
                                        )}
                                        <td className="py-12">
                                            {partsOrderTab.pending === 'active' ?
                                                <>
                                                    <img src='/images/FullFillOrder.svg' alt="FulFillOrder" title="Fulfill Parts Order" className="img-fluid cursor-pointer"
                                                        onClick={() => {
                                                            handleBatchPopup(item.id)
                                                        }}
                                                    />
                                                    <img src="/images/completeOrder.svg" alt="Complete Order" title="Mark as Completed" className="cursor-pointer" onClick={() => setShowCompleteConfirmPopup({ ...showCompleteConfirmPopup, show: true, item: item.id })} />
                                                </>
                                                :
                                                <>
                                                    <img src='/images/InfoIcon.svg' alt="FullFillOrder" title="Parts Order Details" className="img-fluid cursor-pointer"
                                                        onClick={() => {
                                                            handleBatchPopup(item.id)
                                                        }}
                                                    />
                                                </>
                                            }
                                            {item.batch_status != "0" &&
                                                <img src='/images/downloadPlan.svg' alt="downloadPlan" title="Download Pdf" className="img-fluid cursor-pointer ps-1" onClick={() => ExtraDocument(item.fulfill_order_pdf)} />
                                            }
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr> <td colSpan={18} className="p-3 text-center"> No Record Found </td> </tr>
                            )}
                        </tbody>
                    </table>


                </div>
                {showPagination &&
                    <Pagination
                        activePage={currentPage}
                        totalItemsCount={pageRangeCount}
                        pageRangeDisplayed={15}
                        itemsCountPerPage={LimitForPagination}
                        onChange={(e) => { setCurrentPage(e); }}
                        color="primary"
                        lastPageText=""
                        firstPageText=""
                        itemClassFirst="MasterClass"
                        itemClassPrev="MasterClass"
                        itemClassNext="MasterClass"
                        itemClassLast="MasterClass"
                        hideFirstLastPages={true} />
                }
            </div>
            <Popup
                isshow={showBatchPopup}
                isBlur={showSearchBarPopup.show}
                size={"xl"}
                title={partsOrderTab.pending === "active" ? 'Fulfill Parts Order' : 'Parts Order Details'}
                closePopup={(e) => { setFulFillSearch(''); setShowBatchPopup(!showBatchPopup) }}
                modalBody={batchModalBody}
                handleSave={FulFillOrder}
                visibleSaveBtn={partsOrderTab.pending === "active" ? true : false}
                btnText={'Fulfill'}
            />
            <AlertPopup isshow={showCompleteConfirmPopup.show} img={'/images/greenInfo.svg'}
                headingtext={'Move to Completed Orders?'} text={'You are about to mark this order as completed!'}
                cancelcall={(e) => setShowCompleteConfirmPopup({ ...showCompleteConfirmPopup, show: false })}
                canceltext={"No"} successtext={"Yes"}
                successcall={() => FinalizeBatchBilling(showCompleteConfirmPopup.item)} btntype={'SaveBtn'}
            />
            <Popup
                isshow={showSearchBarPopup.show}
                size={"md"}
                title={'Search a part to replace.'}
                closePopup={() => setShowSearchBarPopup({ ...showSearchBarPopup, show: false })}
                modalBody={
                    <>
                        <div className="position-relative d-flex flex-column w-100">
                            <form className="gridsearchbar" onSubmit={(e) => e.preventDefault()}>
                                <div className="position-absolute top-50 translate-middle-y search-icon ms-3 searchIcon">
                                    <i className="bi bi-search"></i>
                                </div>
                                <input
                                    className="form-control"
                                    autoComplete="off"
                                    type="text"
                                    placeholder="Search for a similar part"
                                    value={fullfillSearchText}
                                    onChange={(e) => {
                                        setShowMasterList(true);
                                        setFulFillSearch(e.target.value);
                                        GetMasterList(e.target.value);
                                    }}
                                />
                            </form>
                            {showMasterList && fullfillSearchText?.length > 0 &&
                                <div className="SuggestionBoxDiv position-relative top-100">
                                    {!masterListData.isLoading ? (
                                        masterListData.data?.length > 0 ? masterListData.data.map((item, index) => (
                                            <div key={index} className="py-2 cursor-pointer border-bottom" onClick={(e) => { handleFulFillDevice(item, showSearchBarPopup.item); setFulFillSearch('') }}>
                                                {item.title}
                                            </div>
                                        )) : (
                                            <div className="py-2 text-center">No results found</div>
                                        )
                                    ) : (
                                        <div className="d-flex justify-content-center w-100">
                                            <label className="spinner-border" role="status">
                                            </label>
                                        </div>
                                    )}
                                </div>
                            }
                        </div>
                    </>
                }
                visibleSaveBtn={false}
            />
        </React.Fragment >
    )
}